@if (question.value !== null && question.value !== undefined && question.value !== '') {
  <div class="field-card">
    <span class="field-label">{{ question.label }}</span>
    <span class="field-value">
      <span class="bool-badge" [class.bool-badge--yes]="question.value" [class.bool-badge--no]="!question.value">
        {{ question.value ? '✓ כן' : '✗ לא' }}
      </span>
    </span>
  </div>
}
